export default __webpack_public_path__ + "static/media/manual.b84dad39.svg";